import React from 'react';

const ActressSocialLinks = ({ social, additionalInfo, dmmUrl, className = "" }) => {
  if (!social && !additionalInfo && !dmmUrl) {
    return null;
  }

  const socialPlatforms = [
    {
      key: 'twitter',
      name: 'Twitter',
      icon: '𝕏',
      color: 'bg-black text-white',
      data: social?.twitter
    },
    {
      key: 'instagram',
      name: 'Instagram',
      icon: '📷',
      color: 'bg-gradient-to-r from-purple-500 to-pink-500 text-white',
      data: social?.instagram
    },
    {
      key: 'tiktok',
      name: 'TikTok',
      icon: '🎵',
      color: 'bg-black text-white',
      data: social?.tiktok
    },
    {
      key: 'youtube',
      name: 'YouTube',
      icon: '📺',
      color: 'bg-red-600 text-white',
      data: social?.youtube
    }
  ];

  const paidPlatforms = [
    {
      key: 'onlyfans',
      name: 'OnlyFans',
      icon: '🔞',
      color: 'bg-blue-600 text-white',
      url: social?.onlyfans
    },
    {
      key: 'fanbox',
      name: 'Fanbox',
      icon: '💝',
      color: 'bg-orange-500 text-white',
      url: social?.fanbox
    },
    {
      key: 'fantia',
      name: 'Fantia',
      icon: '💖',
      color: 'bg-pink-500 text-white',
      url: social?.fantia
    }
  ];

  const officialLinks = [
    {
      key: 'officialWebsite',
      name: '公式サイト',
      icon: '🌐',
      color: 'bg-gray-600 text-white',
      url: additionalInfo?.officialWebsite
    },
    {
      key: 'blog',
      name: 'ブログ',
      icon: '📝',
      color: 'bg-green-600 text-white',
      url: additionalInfo?.blog
    },
    {
      key: 'wikipedia',
      name: 'Wikipedia',
      icon: '📖',
      color: 'bg-gray-700 text-white',
      url: additionalInfo?.wikipedia
    },
    {
      key: 'dmm',
      name: 'DMM',
      icon: '🎬',
      color: 'bg-red-600 text-white',
      url: dmmUrl
    }
  ];

  const hasAnySocialLinks = socialPlatforms.some(platform => platform.data) ||
                          paidPlatforms.some(platform => platform.url) ||
                          officialLinks.some(link => link.url);

  if (!hasAnySocialLinks) {
    return null;
  }

  return (
    <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
      <h3 className="text-xl font-bold mb-4">SNS・リンク</h3>
      
      {/* Social Media Links */}
      {socialPlatforms.some(platform => platform.data) && (
        <div className="mb-6">
          <h4 className="text-md font-semibold mb-3 text-gray-700">SNS</h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {socialPlatforms.map(platform => {
              if (!platform.data) return null;
              
              return (
                <a
                  key={platform.key}
                  href={platform.data.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${platform.color} rounded-lg p-3 text-center hover:opacity-90 transition-opacity`}
                >
                  <div className="text-2xl mb-1">{platform.icon}</div>
                  <div className="text-sm font-medium">{platform.name}</div>
                  <div className="text-xs opacity-75">@{platform.data.id}</div>
                  {platform.data.verified && (
                    <div className="text-xs mt-1">✓ 認証済み</div>
                  )}
                </a>
              );
            })}
          </div>
        </div>
      )}

      {/* Paid Content Platforms */}
      {paidPlatforms.some(platform => platform.url) && (
        <div className="mb-6">
          <h4 className="text-md font-semibold mb-3 text-gray-700">有料コンテンツ</h4>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {paidPlatforms.map(platform => {
              if (!platform.url) return null;
              
              return (
                <a
                  key={platform.key}
                  href={platform.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${platform.color} rounded-lg p-3 text-center hover:opacity-90 transition-opacity`}
                >
                  <div className="text-2xl mb-1">{platform.icon}</div>
                  <div className="text-sm font-medium">{platform.name}</div>
                </a>
              );
            })}
          </div>
        </div>
      )}

      {/* Official Links */}
      {officialLinks.some(link => link.url) && (
        <div>
          <h4 className="text-md font-semibold mb-3 text-gray-700">公式リンク</h4>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {officialLinks.map(link => {
              if (!link.url) return null;
              
              return (
                <a
                  key={link.key}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${link.color} rounded-lg p-3 text-center hover:opacity-90 transition-opacity`}
                >
                  <div className="text-2xl mb-1">{link.icon}</div>
                  <div className="text-sm font-medium">{link.name}</div>
                </a>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ActressSocialLinks;